import CadenceIcon from './cadenceIcon.view';

export default CadenceIcon;
